export const PROVIDER_TYPE = {
  GOOGLE_AUTH2: 'google_oauth2',
  FACEBOOK: 'facebook',
  LINE: 'line',
  ONE: 'one',
};

export type ProviderType = typeof PROVIDER_TYPE[keyof typeof PROVIDER_TYPE];
